export class Funcionario {
    constructor(
        public id: number = 0,
        public ci: string = "",
        public nombre: string = "",
        public apellido_paterno: string = "",
        public apellido_materno: string = "",
        public sexo: string = "M",

        public nombre_completo: string = "",
        public info: string = ""
    ) {
    }
}